import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import TwoBitAdapterF from './TwoBitAdapter';
import DivSequenceRendererF from './DivSequenceRenderer';
import BgzipFastaAdapterF from './BgzipFastaAdapter';
import ChromSizesAdapterF from './ChromSizesAdapter';
import IndexedFastaAdapterF from './IndexedFastaAdapter';
import SequenceSearchAdapterF from './SequenceSearchAdapter';
import ReferenceSequenceTrackF from './ReferenceSequenceTrack';
import LinearReferenceSequenceDisplayF from './LinearReferenceSequenceDisplay';
import createExtensionPoints from './createExtensionPoints';
var SequencePlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(SequencePlugin, _Plugin);
  function SequencePlugin() {
    var _this;
    _classCallCheck(this, SequencePlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SequencePlugin).apply(this, arguments));
    _this.name = 'SequencePlugin';
    return _this;
  }
  _createClass(SequencePlugin, [{
    key: "install",
    value: function install(pluginManager) {
      DivSequenceRendererF(pluginManager);
      TwoBitAdapterF(pluginManager);
      BgzipFastaAdapterF(pluginManager);
      ChromSizesAdapterF(pluginManager);
      IndexedFastaAdapterF(pluginManager);
      SequenceSearchAdapterF(pluginManager);
      ReferenceSequenceTrackF(pluginManager);
      LinearReferenceSequenceDisplayF(pluginManager);
      createExtensionPoints(pluginManager);
    }
  }]);
  return SequencePlugin;
}(Plugin);
export { SequencePlugin as default };